import { render, staticRenderFns } from "./KpiCard.vue?vue&type=template&id=b9001896&scoped=true"
import script from "./KpiCard.vue?vue&type=script&lang=js"
export * from "./KpiCard.vue?vue&type=script&lang=js"
import style0 from "./KpiCard.vue?vue&type=style&index=0&id=b9001896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9001896",
  null
  
)

export default component.exports